import ApplicationController from './application_controller'
import { FetchRequest } from '@rails/request.js'

export default class extends ApplicationController {

  static targets = ["textarea", "preview", "list"];
  connect() {
    console.log("did init studentcsv")
  }

  didchange() {
    console.log("did change to " + this.textareaTarget.value);
    this.previewTarget.innerHTML = "";

    let lines = this.textareaTarget.value.split(/[\n]/)
    for (let line of lines) {
      let userdata = line.split(/[,;\t]/)
      this.previewTarget.innerHTML += `<tr><td>${userdata[0]}</td><td>${userdata[1]}</td></tr>`
    }
  }

  printList () {
    let elem = this.listTarget;
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('<link rel="stylesheet" href="/assets/gutenberg.min.css" media="print">');
    mywindow.document.write('<style>thead, th, button, a, svg { display:none; } </style>');

    mywindow.document.write('</head><body ><table>');
    mywindow.document.write(elem.querySelector('tbody').innerHTML);
    mywindow.document.write('</table></body></html>');

    // mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    // mywindow.close();

    return true;
  }
  async submit(e) {
    e.preventDefault();

    var data = [];
    let lines = this.textareaTarget.value.split(/[\n]/)
    for (let line of lines) {
      let userdata = line.split(/[,;\t]/)
      data.push([userdata[0], userdata[1]]);
    }
    let postUrl = window.location.pathname;
    console.log("post to " + postUrl);
    const request = new FetchRequest('post', postUrl, {
      body: JSON.stringify({ students: data })
    })
    const response = await request.perform()
    if (response.ok) {
      const body = await response.text;
      this.flash(`Schüler erfolgreich angelegt!`, "success");
      this.textareaTarget.value = "";
      this.previewTarget.innerHTML = "";
    } else {
      this.flash(`Ups, da hat etwas nicht geklappt!`, "danger");
    }
  }
}
